import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'
import { ISap } from '../models/requestModels'

export class PostSyncCategoryandgroupApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/sap/sync-categoryandgroup',
      requesterInfo,
    })
  }

  public async postSyncCategoryandgroup(request: ISap): Promise<any> {
    return await this.postAsync<any>(request)
  }
}
